<template>
  <form id="frm_action">
    <div class="p-formgrid">

      <!-- LATE FEE Section -->
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Late fee</label>
          <div class="p-col chu-mau-nhat">
            A late fee will apply after the due date. Admins can adjust it for specific rentals.
          </div>
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Late fee threshold</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber id="LATE_FEE_THRESHOLD" v-model="obj_data.LATE_FEE_THRESHOLD" :min="0"
                placeholder="0-Rentals will not incur late fees" />
              <span class="p-inputgroup-addon">day</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Late fee per day</label>
          <div class="p-col">
            <div class="p-inputgroup"> 
              <InputNumber id="LATE_FEE_PER_DAY" v-model="obj_data.LATE_FEE_PER_DAY" placeholder="0.00" :min="0"
              :maxFractionDigits="2" :minFractionDigits="2" />
              <span class="p-inputgroup-addon">$</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 style_title_group_car_infomation"></div>
      <!-- REMINDER Section -->
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Reminder</label>
          <div class="p-col chu-mau-nhat">
            The system'll send users a notification when their rentals are nearing expiry.
          </div>
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Rental Expiry reminder threshold</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber id="RENTAL_EXPIRY_REMINDER_THRESHOLD" v-model="obj_data.RENTAL_EXPIRY_REMINDER_THRESHOLD" :min="0"
                placeholder="0" />
              <span class="p-inputgroup-addon">day</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 style_title_group_car_infomation"></div>
      <!-- CONTACT INFORMATION Section -->
      <!-- Phone number -->
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Hera's contact</label>
          <div class="p-col chu-mau-nhat">
            It will be showed on Website and Application
          </div>
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Phone number - Emergency</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <InputText id="KEY_CONTACT_PHONE" v-model="obj_data.KEY_CONTACT_PHONE" placeholder="+61" />
            </div>
          </div>
        </div>
      </div>
      <!-- Email -->
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Email</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <InputText id="KEY_CONTACT_EMAIL" v-model="obj_data.KEY_CONTACT_EMAIL"
                placeholder="info@heratrading.com.au" />
            </div>
          </div>
        </div>
      </div>
      <!-- work hours -->
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Work hours</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <InputText id="KEY_CONTACT_WORK_HOURS" v-model="obj_data.KEY_CONTACT_WORK_HOURS" placeholder="input" />
            </div>
          </div>
        </div>
      </div>
      <!-- Location -->
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Location</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <Textarea id="KEY_CONTACT_LOCATION" v-model="obj_data.KEY_CONTACT_LOCATION"
                placeholder="input"></Textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 style_title_group_car_infomation"></div>
      <!-- LOYALTY LEVEL Section -->
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Loyalty level</label>
          <div class="p-col chu-mau-nhat">
            Customer level auto-updates based on settings. Loyalty levels are displayed from lowest to highest.
          </div>
        </div>
        <div style="flex: 1;">
          <!-- Đặt các label chung một lần ở đây -->
          <div class="p-col" style="display: flex; gap: 10px; font-weight: bold; margin-bottom: 10px;">
            <div style="flex: 1;">Level</div>
            <div style="flex: 1;">Earning point from</div>
          </div>

          <!-- Vòng lặp chỉ để hiển thị các giá trị -->
          <div class="p-col" v-for="(level, index) in listLoyaltyLevel" :key="index" style="display: flex; gap: 10px;">
            <div style="flex: 1;">
              <div class="p-inputgroup">
                <InputText :id="'level_' + index" v-model="level.level" placeholder="Level" />
              </div>
            </div>
            <div style="flex: 1;">
              <div class="p-inputgroup">
                <InputNumber :id="'earning_point_' + index" v-model="level.earning_point_from" :min="0" 
                  placeholder="Earning point" />
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="col-12 style_title_group_car_infomation"></div>
      <!-- REWARD POINTS Section -->
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Rewards points</label>
          <div class="p-col chu-mau-nhat">
            Determine the conversion rate between points and transactions
          </div>
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Points reward for weekly rental</label>
          <div class="p-col" style="display: flex; gap: 10px;">
            <div style="flex: 1;">
              <div class="p-inputgroup">
                <InputNumber id="POINT_REWARD_FOR_WEEKLY_RENTAL" v-model="obj_data.POINT_REWARD_FOR_WEEKLY_RENTAL" :min="0" :minFractionDigits="2" :maxFractionDigits="2" placeholder="0" />
                <span class="p-inputgroup-addon">point</span>
              </div>
            </div>
            <div style="flex: 1;">
            </div>
          </div>
        </div>

      </div>
      <!-- dollar -->
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Dollar value per point</label>
          <div class="p-col" style="display: flex; gap: 10px;">
            <div style="flex: 1;">
              <div class="p-inputgroup">
                <InputNumber id="DOLLAR_VALUE_PER_POINT" v-model="obj_data.DOLLAR_VALUE_PER_POINT" placeholder="0.01"
                  :min="0" :minFractionDigits="2" :maxFractionDigits="2"
                />
                <span class="p-inputgroup-addon">$</span>
              </div>
            </div>
            <div style="flex: 1;">
            </div>
          </div>
        </div>

      </div>
      <!-- buy a car  -->
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">

        </div>
        <div style="flex: 1;">

          <div class="p-col" style="display: flex; gap: 10px;">
            <div style="flex: 1;">
              <label class="css-bold-text p-col-fixed txt-right">Buy a car - Cumulative spending</label>
              <div class="p-inputgroup">
                <InputNumber id="BUY_A_CAR_CUMULATIVE_SPENDING" v-model="obj_data.BUY_A_CAR_CUMULATIVE_SPENDING" :min="0"
                  placeholder="5,000" />
                <span class="p-inputgroup-addon">$</span>
              </div>
            </div>
            <div style="flex: 1;">
              <label class="css-bold-text p-col-fixed txt-right">Points reward</label>
              <div class="p-inputgroup">
                <InputNumber id="POINTS_REWARD_BUY" v-model="obj_data.POINTS_REWARD_BUY" placeholder="0" :min="0" />
                <span class="p-inputgroup-addon">point</span>
              </div>
            </div>
          </div>
          <span class="chu-nghieng-mau-nhat">For every ${{formatPrice(obj_data.BUY_A_CAR_CUMULATIVE_SPENDING)}} spent on purchasing a car, the user will be granted {{ obj_data.POINTS_REWARD_BUY }}
            points.</span>
        </div>

      </div>
      <!-- sell a car -->
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">

        </div>
        <div style="flex: 1;">

          <div class="p-col" style="display: flex; gap: 10px;">
            <div style="flex: 1;">
              <label class="css-bold-text p-col-fixed txt-right">Sell a car - Cumulative spending</label>
              <div class="p-inputgroup">
                <InputNumber id="SELL_A_CAR_CUMULATIVE_SPENDING" v-model="obj_data.SELL_A_CAR_CUMULATIVE_SPENDING" :min="0"
                  placeholder="5,000" />
                <span class="p-inputgroup-addon">$</span>
              </div>
            </div>
            <div style="flex: 1;">
              <label class="css-bold-text p-col-fixed txt-right">Points reward</label>
              <div class="p-inputgroup">
                <InputNumber id="POINTS_REWARD_SELL" v-model="obj_data.POINTS_REWARD_SELL" placeholder="0" :min="0" />
                <span class="p-inputgroup-addon">point</span>
              </div>
            </div>
          </div>
          <span class="chu-nghieng-mau-nhat">For every ${{formatPrice(obj_data.SELL_A_CAR_CUMULATIVE_SPENDING)}} earned from selling a car, the user will be granted {{ obj_data.POINTS_REWARD_SELL }}
            points.</span>
        </div>

      </div>

      <div class="col-12 style_title_group_car_infomation"></div>
      
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">SEO Settings</label>
          <div class="p-col chu-mau-nhat">
            Manage metadata such as title, description, and keywords to improve your page’s visibility on search engines.
          </div>
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Page Title</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <InputText id="KEY_TITLE_HOME" v-model="obj_data.KEY_TITLE_HOME" placeholder="input" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Meta Description</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <Textarea id="KEY_META_DESC" :rows="5" v-model="obj_data.KEY_META_DESC"
                placeholder="input"></Textarea>
            </div>
          </div>
        </div>
      </div>

        <div class="col-12 style_title_group_car_infomation"></div>

        <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Notification Settings</label>
          <div class="p-col chu-mau-nhat">
            Configure the system to send email notifications. 
          </div>
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Email to receive order</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <Textarea id="EMAIL_TO_RECEIVE_ORDER" :rows="5" v-model="obj_data.EMAIL_TO_RECEIVE_ORDER"
                placeholder="support@domain.com, sales@domain.com, admin@domain.com"></Textarea>
            </div>
            <small style="display:block; margin-top:4px; color:#666; font-size:13px; line-height:1.5;">
              Enter one or more email addresses to send notifications.<br>
              If entering multiple, separate them with a comma <b>(,)</b>.<br>
              <i>Example:</i> support@domain.com, sales@domain.com, admin@domain.com
            </small>
          </div>
        </div>
      </div>
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Email to receive messages</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <Textarea id="EMAIL_TO_RECEIVE_MESSAGES" :rows="5" v-model="obj_data.EMAIL_TO_RECEIVE_MESSAGES"
                placeholder="support@domain.com, sales@domain.com, admin@domain.com"></Textarea>
            </div>
            <small style="display:block; margin-top:4px; color:#666; font-size:13px; line-height:1.5;">
              Enter one or more email addresses to send notifications.<br>
              If entering multiple, separate them with a comma <b>(,)</b>.<br>
              <i>Example:</i> support@domain.com, sales@domain.com, admin@domain.com
            </small>
          </div>
        </div>
      </div>
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Timezone receive email</label>
          <div class="p-col style-box-time-zone">
            <div class="p-inputgroup">
              <Dropdown key="key_timezone" id="timezone" v-model="obj_data.TIMEZONE_RECEIVE_EMAIL" :options="list_timezone" optionLabel="name"
                optionValue="id" placeholder="Select" :filter="true"  />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">Number of days before receiving the first maintenance reminder notice</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber id="NUMBER_DAYS_MAINTENANCE_REMINDER_NOTIFICATIONS_1" v-model="obj_data.NUMBER_DAYS_MAINTENANCE_REMINDER_NOTIFICATIONS_1" :min="0"
                placeholder="0" />
              <span class="p-inputgroup-addon">day</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" style="display: flex; gap: 20px;">
        <div style="flex: 1;">
        </div>
        <div style="flex: 1;">
          <label class="css-bold-text p-col-fixed txt-right">
            Number of days before receiving the 2nd maintenance reminder notice</label>
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber id="NUMBER_DAYS_MAINTENANCE_REMINDER_NOTIFICATIONS_2" v-model="obj_data.NUMBER_DAYS_MAINTENANCE_REMINDER_NOTIFICATIONS_2" :min="0"
                placeholder="0" />
              <span class="p-inputgroup-addon">day</span>
            </div>
          </div>
        </div>
      </div>
      

      <!-- Save Button -->
      <div class="col-12">
        <Toolbar class="fixed-bottom-toolbar div-button">
          <template slot="right">
            <Button label="Save" @click="saveData()" class="main-style-button" />
          </template>
        </Toolbar>
      </div>
    </div>
  </form>
</template>
<script>
import DataServices from '@/core/DataServices'
export default {
  components: {

  },
  props: {
    mode: String,
    model: Object,
    users: Array,
    actionButton: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      key_type_id: 1,
      dataModelMadatory: null,
      componentKeyMadatory: 1,
      listDataMadatory: [],
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      mapServicePrice: {},
      dataModelType: null,
      componentKeyType: 1,
      listDataType: [],
      cke_key: 1,
      listLang: [],
      content_en: '',
      obj_data: {
        KEY_CONTACT_LOCATION: "",
        KEY_CONTACT_WORK_HOURS: "",
        KEY_CONTACT_PHONE: "",
        KEY_CONTACT_EMAIL: null,
        KEY_CONTACT_PREFIX: null,
        LATE_FEE_THRESHOLD: null,
        LATE_FEE_PER_DAY: null,
        DOLLAR_VALUE_PER_POINT: "",
        RENTAL_EXPIRY_REMINDER_THRESHOLD: "",
        POINT_REWARD_FOR_WEEKLY_RENTAL: "",
        BUY_A_CAR_CUMULATIVE_SPENDING: "",
        POINTS_REWARD_BUY: "",
        SELL_A_CAR_CUMULATIVE_SPENDING: "",
        POINTS_REWARD_SELL: "",
        KEY_TITLE_HOME:"",
        KEY_META_DESC:"",
        TIMEZONE_RECEIVE_EMAIL: null,
        NUMBER_DAYS_MAINTENANCE_REMINDER_NOTIFICATIONS_1: null,
        NUMBER_DAYS_MAINTENANCE_REMINDER_NOTIFICATIONS_2: null,

      },
      list_phone_code: [
        { prefix_phone: "+84" },
        { prefix_phone: "+45" },
      ],
      list_whatsapp_code: [
        { prefix_phone_whatsapp: "+84" },
        { prefix_phone_whatsapp: "+45" },
      ],
      listLoyaltyLevel: [],
      list_timezone: [],
      key_timezone: 0,
    }
  },
  watch: {
  },
  async mounted() {
    await this.getSettings();
    await this.getListLoyaltyLevel();
    var where_key = {
      deleted: { _eq: false },
    };
    var list = await this.$CoreService.getListCountry(where_key);
    this.list_timezone =list.list_timezone;
    this.key_timezone ++;
    console.log("Status of actionButton in child component:", this.actionButton.status);
  },
  methods: {
    async getListLoyaltyLevel() {
      var where_key = {
        deleted: { _eq: false },
      };
      var list = await this.$CoreService.getListLoyaltyLevel(where_key);
      this.listLoyaltyLevel = list.list.sort((a, b) => a.earning_point_from - b.earning_point_from);
      console.log('listLoyaltyLevel', this.listLoyaltyLevel);
    },
    async getSettings() {
      var where_key = {
        deleted: { _eq: false },
      }
      let { data } = await this.$apollo.query({
        query: DataServices.getList('setting', { "fields": `id  value  key ` }),
        variables: {
          where_key: where_key,
        },
        fetchPolicy: "network-only"
      });

      let settings = data.setting;

      settings.forEach(setting => {
        switch (setting.key) {
          case 'KEY_CONTACT_LOCATION':
            this.obj_data.KEY_CONTACT_LOCATION = setting.value;
            break;
          case 'KEY_CONTACT_WORK_HOURS':
            this.obj_data.KEY_CONTACT_WORK_HOURS = setting.value;
            break;
          case 'KEY_CONTACT_PHONE':
            this.obj_data.KEY_CONTACT_PHONE = setting.value;
            break;
          case 'KEY_CONTACT_EMAIL':
            this.obj_data.KEY_CONTACT_EMAIL = setting.value;
            break;
          case 'KEY_CONTACT_PREFIX':
            this.obj_data.KEY_CONTACT_PREFIX = setting.value;
            break;
          case 'LATE_FEE_THRESHOLD':
            this.obj_data.LATE_FEE_THRESHOLD = setting.value;
            break;
          case 'LATE_FEE_PER_DAY':
            this.obj_data.LATE_FEE_PER_DAY = setting.value;
            break;
          case 'DOLLAR_VALUE_PER_POINT':
            this.obj_data.DOLLAR_VALUE_PER_POINT = setting.value;
            break;
          case 'RENTAL_EXPIRY_REMINDER_THRESHOLD':
            this.obj_data.RENTAL_EXPIRY_REMINDER_THRESHOLD = setting.value;
            break;
          case 'POINT_REWARD_FOR_WEEKLY_RENTAL':
            this.obj_data.POINT_REWARD_FOR_WEEKLY_RENTAL = setting.value;
            break;
          case 'BUY_A_CAR_CUMULATIVE_SPENDING':
            this.obj_data.BUY_A_CAR_CUMULATIVE_SPENDING = setting.value;
            break;
          case 'POINTS_REWARD_BUY':
            this.obj_data.POINTS_REWARD_BUY = setting.value;
            break;
          case 'SELL_A_CAR_CUMULATIVE_SPENDING':
            this.obj_data.SELL_A_CAR_CUMULATIVE_SPENDING = setting.value;
            break;
          case 'POINTS_REWARD_SELL':
            this.obj_data.POINTS_REWARD_SELL = setting.value;
            break;
          case 'KEY_TITLE_HOME':
            this.obj_data.KEY_TITLE_HOME = setting.value;
            break;
          case 'KEY_META_DESC':
            this.obj_data.KEY_META_DESC = setting.value;
            break;
          case 'EMAIL_TO_RECEIVE_ORDER':
            this.obj_data.EMAIL_TO_RECEIVE_ORDER = setting.value;
            break;
          case 'EMAIL_TO_RECEIVE_MESSAGES':
            this.obj_data.EMAIL_TO_RECEIVE_MESSAGES = setting.value;
            break;
          case 'TIMEZONE_RECEIVE_EMAIL':
            this.obj_data.TIMEZONE_RECEIVE_EMAIL = setting.value;
            break;
          case 'NUMBER_DAYS_MAINTENANCE_REMINDER_NOTIFICATIONS_1':
            this.obj_data.NUMBER_DAYS_MAINTENANCE_REMINDER_NOTIFICATIONS_1 = setting.value;
            break;
          case 'NUMBER_DAYS_MAINTENANCE_REMINDER_NOTIFICATIONS_2':
            this.obj_data.NUMBER_DAYS_MAINTENANCE_REMINDER_NOTIFICATIONS_2 = setting.value;
            break;
        }
      });
      console.log('datasetting', settings);
    },
    async validateData() {
      this.validationErrors = {};

      const fieldsToValidate = [
        { id: "KEY_CONTACT_LOCATION", value: this.obj_data.KEY_CONTACT_LOCATION },
        { id: "KEY_CONTACT_WORK_HOURS", value: this.obj_data.KEY_CONTACT_WORK_HOURS },
        { id: "KEY_CONTACT_PHONE", value: this.obj_data.KEY_CONTACT_PHONE },
        { id: "KEY_CONTACT_EMAIL", value: this.obj_data.KEY_CONTACT_EMAIL },
        { id: "KEY_CONTACT_PREFIX", value: this.obj_data.KEY_CONTACT_PREFIX },
        { id: "LATE_FEE_THRESHOLD", value: this.obj_data.LATE_FEE_THRESHOLD },
        { id: "LATE_FEE_PER_DAY", value: this.obj_data.LATE_FEE_PER_DAY },
        { id: "DOLLAR_VALUE_PER_POINT", value: this.obj_data.DOLLAR_VALUE_PER_POINT },
        { id: "RENTAL_EXPIRY_REMINDER_THRESHOLD", value: this.obj_data.RENTAL_EXPIRY_REMINDER_THRESHOLD },
        { id: "POINT_REWARD_FOR_WEEKLY_RENTAL", value: this.obj_data.POINT_REWARD_FOR_WEEKLY_RENTAL },
        { id: "BUY_A_CAR_CUMULATIVE_SPENDING", value: this.obj_data.BUY_A_CAR_CUMULATIVE_SPENDING },
        { id: "POINTS_REWARD_BUY", value: this.obj_data.POINTS_REWARD_BUY },
        { id: "SELL_A_CAR_CUMULATIVE_SPENDING", value: this.obj_data.SELL_A_CAR_CUMULATIVE_SPENDING },
        { id: "POINTS_REWARD_SELL", value: this.obj_data.POINTS_REWARD_SELL },
        { id: "KEY_TITLE_HOME", value: this.obj_data.KEY_TITLE_HOME },
        { id: "KEY_META_DESC", value: this.obj_data.KEY_META_DESC },
        { id: "EMAIL_TO_RECEIVE_ORDER", value: this.obj_data.EMAIL_TO_RECEIVE_ORDER },
        { id: "EMAIL_TO_RECEIVE_MESSAGES", value: this.obj_data.EMAIL_TO_RECEIVE_MESSAGES },
        { id: "TIMEZONE_RECEIVE_EMAIL", value: this.obj_data.TIMEZONE_RECEIVE_EMAIL },
        { id: "NUMBER_DAYS_MAINTENANCE_REMINDER_NOTIFICATIONS_1", value: this.obj_data.NUMBER_DAYS_MAINTENANCE_REMINDER_NOTIFICATIONS_1 },
        { id: "NUMBER_DAYS_MAINTENANCE_REMINDER_NOTIFICATIONS_2", value: this.obj_data.NUMBER_DAYS_MAINTENANCE_REMINDER_NOTIFICATIONS_2 },
      ];
      for (let i = 0; i < fieldsToValidate.length; i++) {
        let field = fieldsToValidate[i];
        let inputElement = document.getElementById(field.id);

        if (inputElement && (inputElement.tagName.toUpperCase() === "INPUT" || inputElement.tagName.toUpperCase() === "TEXTAREA" || inputElement.tagName.toUpperCase() === "SELECT")) {
          if (this.$commonFuction.isEmpty(field.value)) {
            inputElement.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
          } else {
            inputElement.setCustomValidity("");
          }
        }
      }
      let inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
      return false;
    },
   formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (this.$commonFuction.is_loading(true)) {
        this.$commonFuction.is_loading(false);
        return
      }
      this.obj_data = {
        ...this.obj_data,
        loyaltyLevels: this.listLoyaltyLevel
      };
      console.log('saveData', this.obj_data)

      this.$emit('save', this.obj_data)
    },
  },
}
</script>

<style lang="scss">
.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: .25rem;
  padding-bottom: .25rem;

}

.category-item-value {
  padding: .25rem .5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: .2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
  border-radius: 7px;
}

//style form add-edit
@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}



.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #C8C8C8;
  border-radius: 0px;
  //border-top: none!important;
  //border: 1px solid rgba(60, 60, 60, 0.26);;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
  width: 50px;
}



.p-col-fixed {
  padding: 0px !important;
  //margin:0px 0px 0px 10px !important;
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #C8C8C8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}


//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }

  .div-button {
    padding: 8px !important;
  }

  .p-inputgroup-addon {
    margin-right: 12px;
  }

  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

.p-button-outlined {
  .p-button-label {
    color: #FFDF01 !important;
  }
}

.cus-text {
  margin-left: 2px;
  margin-top: 4px;
}

.style-box-phone {
  border: 1px solid #a6a6a6;
  width: 100%;
  display: flex;

  .p-dropdown {
    width: 100px;
    border: 0px;
    box-shadow: none !important;
  }

  .p-focus {
    border: 0px;
    box-shadow: none;
  }

  .p-dropdown:focus {
    border: 0px;
    box-shadow: none;
  }

  input {
    width: calc(100% - 100px);
    margin-left: 0px;
    border: 0px;
  }

  .p-inputtext:enabled:focus {
    border: 0px;
    box-shadow: none;
  }
}

.style_list_image {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;

  .box-image {
    width: 100px;
    height: 100px;
    margin-top: 8px;
    margin-bottom: 8px;
    position: relative;

    .style_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #D0D4D9;
      border-radius: 10px;
    }

    .button-clear {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 1px;
      right: 8px;
    }
  }
}

.style_box_room {
  display: flex;
}

.style_box_lat_log {
  display: flex;

  .box_lat_log {
    width: 50%;
  }
}

.style_title_group {
  padding: 10px 0 0 0 !important;
  font: normal normal bold 20px/27px Segoe UI;
  letter-spacing: 0px;
  color: #333333;
  text-transform: uppercase;
}

.style_box_price {
  padding-left: 35px !important;
}

.style_rad_button {
  label {
    margin-bottom: 0px;
    margin-left: 15px;
  }
}

.style_btn_add_type {
  width: 60px;
}



.custom-height {
  height: 5rem;
  padding-bottom: 2rem;
  /* Tạo khoảng cách giữa nội dung và phần trên */
  line-height: 1.5rem;
  /* Điều chỉnh độ cao dòng của nội dung */
}

.style_title_group_car_infomation {
  position: relative;
  margin-top: 10px;
  margin-bottom: 30px;
}

.style_title_group_car_infomation::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 1px;
  background-color: #d3d0d0;
  transform: translateX(-15px);
}

.chu-mau-nhat {
  color: #8a8a8a;
  font-size: 16px;
  font-weight: 400;
}

.chu-nghieng-mau-nhat {
  color: #8a8a8a;
  font-size: 16px;
  font-weight: 400;
  font-style: italic;
  margin-left: 10px;
}

.p-inputgroup-addon {
  background-color: #D0D4D9;
  border: none !important;
}

.css-bold-text {
  font-weight: bold;
}
.style-box-time-zone{
  .p-dropdown-filter{
    width: 100% !important;
  }
}

</style>
